import { Store } from 'src/store/index';

const getClipartSearchString = (store: Store) => store.addon.searchString;
export default getClipartSearchString;
